import React, { ChangeEvent, Component, useState } from "react";
import PapaParse, { ParseError, ParseResult } from "papaparse";
import ActivityIndicator from "../ActivityIndicator/ActivityIndicator";

type Props = {
    onFileLoaded: (csvData: ParseResult<any>, filename: string) => void;
    hasHeader?: boolean;
    isProcessing: boolean;
    /**
     * Setting this to null will clear the input file
     */
    value?: string;
};

const OwCsvReader = (props: Props) => {
    const [fileEncoding, setFileEncoding] = useState("UTF-8");

    const onError = (error: ParseError, file?: File) => {
        // console.log("onError", error);
    };

    const onFileLoaded = (csvData: ParseResult<any>, filename: string) => {
        props.onFileLoaded(csvData, filename);
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const reader = new FileReader();

        if (e.target.files?.length && e.target) {
            const filename = e.target.files[0].name;

            reader.onload = (progressEvent: ProgressEvent<FileReader>) => {
                if (progressEvent.target?.result) {
                    // @ts-expect-error
                    const csvData = PapaParse.parse(progressEvent.target.result.toString(), {
                        error: onError,
                        encoding: fileEncoding,
                        header: props.hasHeader || true,
                        skipEmptyLines: true,
                    });

                    // @ts-expect-error
                    onFileLoaded(csvData, filename);
                }
            };

            reader.readAsText(e.target.files[0], fileEncoding);
        }
    };
    
    return (
        <div className="OwCsvReader d-flex">
            <input className={""} type={"file"} onChange={handleFileChange} value={props.value} />

            <div>
                <ActivityIndicator className={"ms-2"} active={props.isProcessing} />
            </div>
        </div>
    );
}

export default OwCsvReader;
